/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListAttachmentData } from './genericApiResponseListAttachmentData';
import type { GenericApiResponseListAttachmentMessage } from './genericApiResponseListAttachmentMessage';
import type { GenericApiResponseListAttachmentPagination } from './genericApiResponseListAttachmentPagination';
import type { GenericApiResponseListAttachmentError } from './genericApiResponseListAttachmentError';

export interface GenericApiResponseListAttachment {
  data?: GenericApiResponseListAttachmentData;
  message?: GenericApiResponseListAttachmentMessage;
  pagination?: GenericApiResponseListAttachmentPagination;
  error?: GenericApiResponseListAttachmentError;
  statusCode?: number;
}
